export default {"src":"/_next/static/media/icon_search.5f8a4c87.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};